/* eslint-disable camelcase */
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import useUrlQuery from 'Hooks/useUrlQuery';
import { useConfig } from 'Src/contexts/Config';
import { VALID_PAYMENT } from 'Utils/queries';

import { useValidPaymentQueryFn } from './useValidPayment';

/**
 * Imperative version of useValidPayment
 * DEPRECATED: use "useValidPayment" instead, it is more declarative
 * TODO: Remove this function when Landing.jsx and useSession.jsx are refactored
 */
export default function useFetchValidPayment() {
  const { payment_id, payment_intent_id } = useUrlQuery();
  const {
    features: {
      VALIDATE_PAYMENT_WITH_TOKEN: useSignature,
    },
  } = useConfig();
  const client = useQueryClient();

  return useCallback(async () => {
    const payment = await client.fetchQuery({
      queryFn: () => useValidPaymentQueryFn({ payment_id, payment_intent_id, useSignature }),
      queryKey: [VALID_PAYMENT, payment_id, payment_intent_id],
    });

    return payment;
  }, [client, payment_id, payment_intent_id]);
}
